// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nolimit .overlay {
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 2147483645;
    display: none;

    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.nolimit.overlay .overlay {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
}

.nolimit.overlay .overlay {
    background-color: rgba(0, 0, 0, 0);
}

.nolimit.overlay .overlay.blackout {
    background-color: rgba(0, 0, 0, 1);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nolimitcity/game-api/src/css/overlay.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".nolimit .overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    overflow: hidden;\n    z-index: 2147483645;\n    display: none;\n\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n}\n\n.nolimit.overlay .overlay {\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.nolimit.overlay .overlay {\n    background-color: rgba(0, 0, 0, 0);\n}\n\n.nolimit.overlay .overlay.blackout {\n    background-color: rgba(0, 0, 0, 1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
